import { baseUrl } from "@/requestConfig/baseUrl";
import axios from "@/requestConfig/intercept";
import { Response } from "../index.limit";
import { IUserInfo, ReqCallback, ReqConfig, ReqLogin, ReqUploadFilesMultipleWeCom, ReqUploadFilesWeCom, ResAuthority, ResCallBack, ResCheckWxUser, ResConfig, ResToken } from "./index.limit";
export * from "./index.limit";
import { Files } from "../knowledge";

const { api, newServer, ThirdPartyTask } = baseUrl;

/**
 * 登录
 */
export const apiLogin = (data: ReqLogin): Promise<Response<ResToken>> => {
  return axios.post(`${api}/User/Login`, data);
};

/**
 * 获取配置信息
 */
export const apiGetJsTicketConfig = (params: ReqConfig): Promise<Response<ResConfig>> => {
  return axios.get(`${api}/work/GetJsTicketConfig`, { params });
};

/**
 * 上传文件
 */
export const apiUploadFiles = (data: FormData): Promise<Response<Files[]>> => {
  return axios.post(`${api}/Common/UploadFiles`, data, {
    timeout: 60000 * 10,
  });
};

/**
 * 检查企业是否授权
 */
export const apiCheckCorpAuthoer = (params: { corpId: string }): Promise<Response<string>> => {
  return axios.get(`${api}/work/checkCorpAuthoer`, { params });
};

/**
 * 企业管理员授权
 */
export const apiCompanyAuthor = (data: ReqLogin): Promise<Response<string>> => {
  return axios.post(`${api}/work/companyAuthor`, data);
};

/** 登录授权回调 */
export const apiCallback = (params: ReqCallback): Promise<Response<ResCallBack>> => {
  return axios.get(`${api}/user/callback`, { params });
};

/**
 * 上次临时素材到企微微信
 */
export const apiUploadFilesWeCom = (params: ReqUploadFilesWeCom): Promise<Response<string>> => {
  return axios.get(`${api}/Common/UploadFilesWeCom`, { params });
};
/**
 * 上传多个临时素材到企业微信jpg/png是图片类型；其它是文件类型
 */
export const apiUploadFilesMultipleWeCom = (data: ReqUploadFilesMultipleWeCom): Promise<Response<string[]>> => {
  return axios.post(`${api}/Common/UploadFilesMultipleWeCom`, data);
};
/**
 * 获取权限
 */
export const apiAuthority = (): Promise<Response<ResAuthority>> => axios.get(`${api}/User/Authority`);

/**
 * 检查企业成员是否绑定crs账号 返回code非200 清除token
 */
export const apiCheckwxuser = (params: { corpId: string }): Promise<Response<ResCheckWxUser>> => axios.get(`${api}/user/checkwxuser`, { params });

//获取token 登录crs
export const commonNewLoginApi = (data: URLSearchParams) => {
  return axios.post(`${newServer}/connect/token`, data);
};
//获取token 采集登录
export const commonLoginApi = (params: { serial: string; userId: string; userName: string; productVersion: number }) => {
  return axios.post(`${ThirdPartyTask}/User/Login`, params);
};
/**
 * 获取登录用户信
 * GET
 * /user/userinfo
 */
export const ApiUserinfo = (): Promise<Response<IUserInfo>> => axios.get(`${api}/user/userinfo`);
/**
 * 取消企业号绑定
 * POST
 * /manage/CancelSerialBind
 */
export const ApiCancelSerialBind = (): Promise<Response<string>> => axios.post(`${api}/manage/CancelSerialBind`);

/**
 * GET
 * /Common/FileDownLoad
 * 下载文件返回流
 */
export const ApiDownloadFile = (params: { fileName: string; fileUrl: string }): Promise<Blob> =>
  axios.get(`${api}/Common/FileDownLoad`, {
    params,
    responseType: "blob",
  });

/**
 * 获取授权登录链接（已关联情况下或者企业微信绑定手机号与crs子账号手机号一致授权登录）
 */
export const apiAuthUrl = (corpId: string): Promise<Response<string>> => axios.post(`${api}/User/authUrl?corpId=${corpId}`);
/**
 * 用户退出
 * GET
 * /user/userexit
 */
export const ApiUserExit = (params: { type: 1 | 2 }): Promise<Response<string>> => axios.get(`${api}/user/userexit`, { params });
